import { render, staticRenderFns } from "./Journals.vue?vue&type=template&id=bf23bdee"
import script from "./Journals.vue?vue&type=script&lang=js"
export * from "./Journals.vue?vue&type=script&lang=js"
import style0 from "./Journals.vue?vue&type=style&index=0&id=bf23bdee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports